export default (node) => {
  const textureSelectButtons = node.querySelectorAll('[data-texture-selector]');
  const selectedTextureText = node.querySelector('[data-selected-texture-text]');
  const outOfStockLabel = node.querySelector('[data-texture-out-of-stock]');
  const textureGuideModal = node.querySelector('[data-texture-guide-modal]');

  // Read variant data from embedded JSON script tag (self-contained, no dependency on other components)
  const variantJsonEl = node.querySelector('[data-variant-json]');
  let allVariants = [];
  try {
    allVariants = JSON.parse(variantJsonEl?.textContent || '[]');
  } catch (e) {
    console.error('[textureSelect] Failed to parse variants', e);
  }
  /**
   * Functions
   */
  const updateSelectedTextureText = (texture) => {
    if (selectedTextureText) {
      selectedTextureText.innerHTML = texture;
    }
  };

  const changeSelectedTexture = (button) => {
    const { texture } = button.dataset;
    outOfStockLabel?.classList.add('hidden');

    // Remove active class from all buttons
    textureSelectButtons.forEach((btn) => {
      btn.classList.remove('texture-selector--active');
    });

    // Add active class to the clicked button
    button.classList.add('texture-selector--active');

    // Update the texture text display
    updateSelectedTextureText(texture);

    // Show texture guide modal if texture guide modal image is curly
    if (texture.toLowerCase().includes('curly')) {
      textureGuideModal.classList.add('flex');
      textureGuideModal.classList.remove('hidden');
    } else {
      textureGuideModal.classList.remove('flex');
      textureGuideModal.classList.add('hidden');
    }

    // Show out of stock label if this texture is sold out
    if (button.classList.contains('texture-selector--sold-out')) {
      outOfStockLabel?.classList.remove('hidden');
    }

    // Update add to cart button with selected texture
    document.dispatchEvent(
      new CustomEvent('add-to-cart:selected-texture-change', {
        detail: { texture },
      })
    );

    // Update carousel to show images for new texture
    document.dispatchEvent(
      new CustomEvent('product-image:texture-change', {
        detail: { texture },
      })
    );

    // CASCADE DOWN: Update size availability based on selected texture
    document.dispatchEvent(
      new CustomEvent('size-select:filter-by-texture', {
        detail: { texture, allVariants },
      })
    );

    // CASCADE DOWN: Update color visibility based on selected texture
    document.dispatchEvent(
      new CustomEvent('color-select:filter-by-texture', {
        detail: { texture, allVariants },
      })
    );
  };

  const init = () => {
    textureSelectButtons.forEach((button) => {
      button.addEventListener('click', () => changeSelectedTexture(button));
    });

    // Trigger availability cascade on initial load
    // Deferred so all components (sizeSelect, colorSelect) have mounted
    // and registered their event listeners first
    const activeButton = node.querySelector('.texture-selector--active');
    if (activeButton && allVariants.length > 0) {
      setTimeout(() => {
        changeSelectedTexture(activeButton);
      }, 0);
    }
  };

  /**
   * Init
   */
  init();
};
